
export default function Features() {
  const features = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Swedish Massage',
      description: 'Gentle, flowing strokes to promote relaxation and improve circulation throughout your entire body.',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Deep Tissue',
      description: 'Targeted pressure to release chronic muscle tension and address specific areas of discomfort.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Hot Stone Therapy',
      description: 'Smooth heated stones combined with massage to melt away tension and promote deep relaxation.',
    },
    {
      icon: 'ri-spa-line',
      title: 'Aromatherapy',
      description: 'Essential oils enhance your massage experience, calming the mind and soothing the senses.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Prenatal Massage',
      description: 'Specialized care for expectant mothers, providing comfort and relief during pregnancy.',
    },
    {
      icon: 'ri-football-line',
      title: 'Sports Massage',
      description: 'Performance-focused techniques to aid recovery, prevent injury, and enhance athletic performance.',
    },
  ];

  return (
    <section id="features" className="py-32 px-8 lg:px-16 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl lg:text-5xl font-light text-center text-[#2C2C2C] mb-20" style={{ fontFamily: 'Georgia, serif' }}>
          Our Services
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-4xl text-[#A8B5A0]`}></i>
              </div>
              <h3 className="text-xl font-light text-[#2C2C2C] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                {feature.title}
              </h3>
              <p className="text-sm text-[#6B6B6B] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
